import { Dispatch, SetStateAction, useEffect, useState } from 'react';
// import {
//   FlexBetween,
//   FlexJustifyCenter,
//   HubLengthMessage
// } from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { FlexJustifyCenter, HubLengthMessage } from '../../styles/stylesStyled';
import { AnimatedItem } from '../../components/animation/AnimatedItem';
import {
  AnimatedDashboard,
  AnimatedTab,
  Button,
  SidebarModal
} from '../../components';
import { formatUSD, formatUSDNoDecimals } from '../../helpers/helperFunctions';
import { InvoiceHeader, Invoices } from './OrdersStyled';
import {
  Invoice,
  MyOrderListModel,
  OrderItem,
  Payment
} from '../Marketplace/Maeketplace.types';
import { useAppSelector } from '../../app/hooks';
import { useParams } from 'react-router-dom';
import { getOrders } from '../../slices/orders-slice';
import { useDispatch } from 'react-redux';

export const InvoicesTicket = ({
  payments
}: {
  payments: Payment[] | undefined;
}) => {
  return (
    <>
      <InvoiceHeader>
        <div style={{ width: '10%' }}>Id</div>
        <div style={{ width: '15%' }}>Amount</div>
        {/* <div style={{ width: '20%' }}>Date Created</div> */}
        <div style={{ width: '50%', textAlign: 'center' }}>Wallet</div>
        <div style={{ width: '30%', textAlign: 'right' }}>Currency</div>
      </InvoiceHeader>
      {payments?.map((inv: Payment, i: number) => {
        return (
          <AnimatedItem key={i} index={i}>
            <Invoices>
              <div style={{ width: '10%' }}>{inv.id}</div>
              <div style={{ width: '15%' }}>
                {' '}
                {formatUSDNoDecimals(inv.amount)}
              </div>

              {/* <div style={{ width: '20%' }}>
                {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
              </div> */}

              <div style={{ width: '50%' }}>{inv?.details?.walletAddress}</div>
              <div style={{ width: '30%', textAlign: 'right' }}>
                {inv?.currencyId === 7 ? 'USDC' : 'USDT'}
              </div>
            </Invoices>
          </AnimatedItem>
        );
      })}
    </>
  );
};
